import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BaseApiTemplateService} from '../../shared';
import {InventoryItemHeaderContainerModel} from '../../../../../../models/aggregates/erp/inventory';
import {Core2Config} from '../../shared';


@Injectable({
  providedIn: 'root'
})
export class InventoryItemHdrService extends BaseApiTemplateService<InventoryItemHeaderContainerModel> {
  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.INV_PREFIX + "inv-items/hdrs";

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.INV_PREFIX + "inv-items/hdrs";
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.INV_PREFIX + "inv-items/hdrs";
    this.httpClient = http;
  }

}


